import {ICategory} from 'entities/categories/model/ICategory';

export const getHref = (category: ICategory) => {
    let href = '/';
    if (category.ancestors && category.ancestors.length > 0) {
        href += `${category.ancestors[0]?.slug}/`;
    }
    href += `${category.slug}`;
    return href;
};